<app-tab-group class="general-infos" [tabGroup]="tabGroup">
    <ng-template appStaticTabsContent>
        <div class="general-infos__static-tabs__first-tab-content">
            <app-companies (company)="displayCompanyInfosInTabs($event)">
            </app-companies>
        </div>
    </ng-template>
    <ng-template appStaticTabsContent>
        <div class="general-infos__static-tabs__second-tab-content">
            <app-roles (onEdit)="displayEditRolesInTab($event)" (onConfigure)="displayConfigureRolesInTab($event)" (onNotice)="displayNoticeRolesInTab($event)">
            </app-roles>
        </div>
    </ng-template>
    <ng-template #dynamicTabsContent let-infos>
        <div class="general-infos__dynamic-tabs">
            <app-informations [infos]=" infos ">
            </app-informations>
        </div>
    </ng-template>
</app-tab-group>

<form [formGroup]="fileForm" class="general-infos__upload-files">

    <app-upload-files formControlName="files" class="general-infos__upload-files__cmp" [multiple]="true" [maxSizeByFile]="5">
        <!-- <ng-template labelFileInputTrigger> <label for="fileInput">Select some files</label> </ng-template> -->
    </app-upload-files>
    <button id="general-infos__upload-files-form__upload-btn" class="general-infos__upload-files-form__upload-btn" mat-raised-button (click)="uploadFiles()" color="primary"> Upload files </button>
</form>